//#region ../../packages/constants/form.ts
const MINIMUM_INPUT_WIDTH = 11;
const BORDER_HORIZONTAL_WIDTH = 2;

//#endregion
export { BORDER_HORIZONTAL_WIDTH, MINIMUM_INPUT_WIDTH };
//# sourceMappingURL=form.mjs.map